/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { DayCalendarSkeleton, LocalizationProvider, PickersDay } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar, PickersDayProps } from '@mui/x-date-pickers';
import 'dayjs/locale/pt-br';
import dayjs, { Dayjs } from 'dayjs';
import Badge from '@mui/material/Badge';
import { Box, Popover, Typography } from '@mui/material';

export interface FormatedDate {
	date?: string;
	datas?: string;
	uuid?: string;
	frequencia: string;
	descricao: string;
	tempo?: string;
	nome: string;
}

const padZero = (num: number): string => num < 10 ? `0${num}` : `${num}`;

function ServerDay(props: PickersDayProps<Dayjs> & { highlightedDates?: Dayjs[] }) {
	const { highlightedDates = [], day, outsideCurrentMonth, ...other } = props;

	const isSelected =
		!outsideCurrentMonth && highlightedDates.some((highlightedDay) => dayjs(day).isSame(highlightedDay, 'day'));

	return (
		<Badge
			key={day.toString()}
			overlap="circular"
			badgeContent={isSelected ? '🎫' : undefined}
		>
			<PickersDay {...other} outsideCurrentMonth={outsideCurrentMonth} day={day} />
		</Badge>
	);
}

type VCalendarProps = {
	values: FormatedDate[];
}

export function VCalendar({ values }: VCalendarProps) {
	console.log(values);

	const [highlightedDates, setHighlightedDates] = useState<Dayjs[]>([]);

	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const [selectedInfo, setSelectedInfo] = useState<{ date: Dayjs; nome: string } | null>(null);
	

	const handleDayClick = (day: Dayjs, event: React.MouseEvent<HTMLElement>) => {
		const matched = values.find(item => {
			const dateValue = item.date || item.datas || (item as any).dias;
			if (!dateValue) return false;

			const parts = dateValue.split(',').map((s: string) => s.trim());
			return parts.some((p: string | number | dayjs.Dayjs | Date | null | undefined) => {
				const parsed = dayjs(p, 'DD/MM/YYYY');
				return parsed.isValid() && parsed.isSame(day, 'day');
			});
		});

		if (matched) {
			setSelectedInfo({ date: day, nome: matched.nome });
			setAnchorEl(event.currentTarget);
		}
	};

	const handleClosePopover = () => {
		setAnchorEl(null);
		setSelectedInfo(null);
	};

	const open = Boolean(anchorEl);


	useEffect(() => {
		const datesToHighlight: Dayjs[] = [];

		values.forEach(item => {

			const dateValue = item.date || item.datas || (item as any).dias;

			if (dateValue && item.frequencia) {
				if (item.frequencia === 'unica') {
					const parsedDate = dayjs(dateValue, 'DD/MM/YYYY');
					if (parsedDate.isValid()) {
						datesToHighlight.push(parsedDate);
					}
				} else if (item.frequencia === 'semanal') {
					const dateStrings = dateValue.split(',').map((s: string) => s.trim());

					dateStrings.forEach((dateStr: string) => {
						const parsedDate = dayjs(dateStr, 'DD/MM/YYYY');
						if (parsedDate.isValid()) {
							datesToHighlight.push(parsedDate);
						}
					});
				} else if (item.frequencia === 'mensal') {
					const dateStrings = dateValue.split(',').map((s: string) => s.trim());

					dateStrings.forEach((dateStr: string) => {
						const parts = dateStr.split('/');
						if (parts.length === 3) {
							const day = parseInt(parts[0], 10);
							const month = parseInt(parts[1], 10);
							const year = parseInt(parts[2], 10);

							const formattedDateStr = `${padZero(day)}/${padZero(month)}/${year}`;

							const parsedDate = dayjs(formattedDateStr, 'DD/MM/YYYY');
							if (parsedDate.isValid()) {
								datesToHighlight.push(parsedDate);
							}
						}
					});
				} else if (item.frequencia === 'quinzenal') {
					const dateStrings = dateValue.split(',').map((s: string) => s.trim());

					dateStrings.forEach((dateStr: string) => {
						const parsedDate = dayjs(dateStr, 'DD/MM/YYYY');
						if (parsedDate.isValid()) {
							datesToHighlight.push(parsedDate);
							datesToHighlight.push(parsedDate.add(15, 'day'));
						}
					});
				}
			}
		});

		setHighlightedDates(datesToHighlight);
	}, [values]);

	dayjs.locale('pt-br');

	const dayOfWeekFormatter = (date: Dayjs) => {
		const daysOfWeek = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'];
		return daysOfWeek[date.day()];
	};

	return (
		<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
			<DateCalendar
				renderLoading={() => <DayCalendarSkeleton />}
				slots={{
					day: (props) => (
						<div onClick={(e) => handleDayClick(props.day, e as any)}>
							<ServerDay {...props} />
						</div>
					)
				}}
				slotProps={{
					day: {
						highlightedDates,
					} as any,
				}}
				dayOfWeekFormatter={dayOfWeekFormatter}
			/>
			<Popover
				open={open}
				anchorEl={anchorEl}
				onClose={handleClosePopover}
				anchorReference="anchorPosition"
				anchorPosition={{ top: window.innerHeight / 2.2, left: window.innerWidth / 5 }}

				// transformOrigin={{
				// 	vertical: 'center',
				// 	horizontal: 'center',
				// }}
			>
				<Box p={2}>
					<Typography variant="body1">
						{selectedInfo?.nome ?? 'Sem nome'}
					</Typography>
				</Box>
			</Popover>

		</LocalizationProvider>
	);
}